module.exports = __webpack_public_path__ + "media/images/Logout-9316157edb670e65bd5ab00247cb3bc6.svg";